import Swiper from "swiper";
import { Pagination } from "swiper/modules";

const initBookingCardSlider = () => {
  const swipers = document.querySelectorAll(".js-booking-card-carousel");

  if (swipers.length === 0) return;

  swipers.forEach((swiper) => {
    // eslint-disable-next-line no-unused-vars
    const carousel = new Swiper(swiper, {
      speed: 600,
      lazyPreloadPrevNext: false,
      pagination: {
        el: ".swiper-pagination.swiper-pagination-booking-card",
        type: "bullets",
        clickable: true,
      },
      modules: [Pagination],
    });
  });
};

export default initBookingCardSlider;
